import { requireUid } from './auth';
import { paths } from './paths';
import { readOptionalValue, removeValue } from './rtdb';

/**
 * L'annonce d'une nouvelle version, et qui doit la voir.
 *
 * Ce que la base publie est le dernier build **approuve** par Apple ou
 * par Google, chacun sous sa plateforme : voir
 * `tools/annoncer-la-version.mjs`. Les deux magasins n'approuvent pas le
 * meme jour, d'ou deux numeros. L'ecran compare celui de sa plateforme
 * au sien, et se tait quand il est a jour.
 *
 * D'ou la demande, posee sous un compte : elle force l'annonce chez
 * quelqu'un qui a deja la version. C'est le seul moyen, pour qui publie
 * les versions, de voir ce que recoivent les autres. Elle ne sert qu'une
 * fois — repondre l'efface.
 */
export interface AnnonceDeVersion {
  version: string;
  build: number;
  forcee: boolean;
}

export async function lireLAnnonce(
  plateforme: 'ios' | 'android',
): Promise<AnnonceDeVersion | null> {
  const uid = requireUid();
  const [publiee, demande] = await Promise.all([
    readOptionalValue<{ version?: string; build?: number }>(paths.versionPubliee(plateforme)),
    readOptionalValue<boolean>(paths.annonceAVoir(uid)),
  ]);
  if (!publiee?.build) return null;
  return { version: publiee.version ?? '', build: publiee.build, forcee: demande === true };
}

export async function oublierLaDemande(): Promise<void> {
  await removeValue(paths.annonceAVoir(requireUid()));
}
